module.exports = __webpack_public_path__ + "img/about-illustration-mobile@2x.74bbc1c2.png";